var ConvertService = function() {
    return this;
};

ConvertService.prototype.fetch = function fetch() {};

export default ConvertService;
